module.exports = __webpack_public_path__ + "img/aiIcon-fr.deafc49e.svg";